export default __webpack_public_path__ + "static/virtualupiidforb2bpayments-4b8982fc396bc370539ae4e244feaed3.webp";